import { Text, View } from '@react-pdf/renderer';
import { DefaultTheme } from 'styled-components/dist/types';

interface UpdatesSummaryPDFTemplateHeaderProps {
  theme: DefaultTheme;
  leftSideText: string;
  rightSideText: string;
}

export const UpdatesSummaryPDFTemplateHeader = ({ theme, leftSideText, rightSideText }: UpdatesSummaryPDFTemplateHeaderProps) => {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'absolute',
        top: 0,
        left: 0,
        height: '60px',
        width: '100%',
        padding: '0 60px',
        backgroundColor: theme.layer[12],
        fontFamily: 'Open Sans'
      }}
      fixed
    >
      <Text
        style={{
          fontSize: '16px',
          fontWeight: 700,
          color: theme.font.strong
        }}
      >
        {leftSideText}
      </Text>
      <Text
        style={{
          fontSize: '13px',
          color: theme.font.base
        }}
      >
        {rightSideText}
      </Text>
    </View>
  );
};
